import cn from 'classnames';
import { AICampaignIcon, getSelectedCampaignOption } from 'features/AICampaign/AICampaignIcon';
import { AICampaign } from 'features/AICampaign/interface';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { FastPaymentConfig } from 'shared/constants/common';
import { useDeposit } from 'shared/hooks/useDeposit';
import { BalanceState, State } from 'shared/interface';
import { isLoggedin } from 'shared/util/utility';

interface Props {
	onReady?: () => void;
	location: 'mobile-homepage' | 'web-coupon';
	className: string;
}

const TopUpAccount: React.FC<Props> = (props) => {
	const { t } = useTranslation();
	const [show, setShow] = useState(false);
	const balanceData = useSelector<State, BalanceState>((state) => state.cpPanel.balanceData);
	const userDetails = useSelector<State, any>((state) => state.login.userDetails);
	const isUser = isLoggedin();
	const { openDepositPanel } = useDeposit();
	const selectedCampaignOption = getSelectedCampaignOption();
	const isAIOption = selectedCampaignOption === AICampaign.AI;

	const initializeData = async () => {
		const show = !balanceData.mainBalance || balanceData.mainBalance < FastPaymentConfig.MAX_DEPOSIT_AMOUNT;
		show && props.onReady?.();
		setShow(show);
	};
	useEffect(() => {
		if (isUser) {
			userDetails?.login && initializeData();
		} else {
			setShow(false);
		}
	}, [isUser]);

	useEffect(() => {
		if (isUser && balanceData?.depositInfo) {
			initializeData();
		}
	}, [balanceData]);

	return show ? (
		<div
			className={cn('text-paragraph-xs font-semibold text-white bg-primary-500 dark:bg-dark-200 cursor-pointer', props.className)}
			onClick={() => openDepositPanel()}
		>
			<div className={'flex items-center'}>
				{selectedCampaignOption ? (
					<AICampaignIcon selectedOption={selectedCampaignOption} location={props.location} />
				) : (
					<div className={'mr-2 text-h3 py-2'}>💔</div>
				)}

				<div>
					{isAIOption ? (
						<>
							<div>{t('aiDetection')}</div>
							<div>{t('aiSuggestion')}</div>
						</>
					) : (
						<>
							<div>{t('topUpMessage1')}</div>
							<div>{t('topUpMessage2')}</div>
						</>
					)}
				</div>
			</div>
		</div>
	) : null;
};
export default memo(TopUpAccount);
